import React from 'react'

const RewardToken = () => {
    return (
        <div className="_reward_nft_btm_wrapper">
            <div className="container">
                <div className="row">
                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                        <h6 className="_reward_nft_stake_box_txt">AB Token helps you earn reward, it’s neat.</h6>
                        <h3 className="_reward_nft_stake_box_title">Get the token that powers AllBlocks.</h3>
                        <div className="_reward_nft_stake_title_btn_wrap">
                            <a href="#0" className="_reward_nft_stake_title_btn1">buy book</a>
                            <a href="#0" className="_reward_nft_stake_title_btn2">add to wallet <span className="_reward_nft_stake_title_btn2_ic"><svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" viewBox="0 0 24 24">
                                <path stroke="#292D32" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M6 12h12m-6 6V6" />
                            </svg>
                            </span></a>
                        </div>
                        <p className="_reward_nft_stake_box_txt _bottom">It is a long established fact that a reader will be
                            distracted
                            by the readable
                            \content of a page when looking at its layout. The point of using </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default RewardToken;